import React, { useMemo } from 'react';
import { CollapseRow } from './CollapseRow';
import NoItemsTableContent from './NoItemsTableContent';
import { SingleQuoteTableContent, SingleInvoiceTableContent } from './SingleQuoteTableContent';
import { EndUserCollapseRow } from './EndUserCollapseRow';

export enum MACTableType {
  licenses = 'licenses',
  orders = 'orders',
  invoices = 'invoices',
}

const isQuoteDisplayable = (quote: any): boolean => {
  const validStatuses = ['QUOTED', 'REVIEW_REQUIRED', 'ORDER_PLACED', 'PROCESSED', 'DELETED'];
  if (quote.is3DSQuote) return false;
  if (!validStatuses.includes(quote.status)) return false;
  if (
    quote.status === 'DELETED' &&
    !['completed', 'inprogress'].includes(quote.ccpQuoteMigrationStatus)
  )
    return false;
  return true;
};

type MACTableContentProps = {
  items: any[];
  tableType: MACTableType;
  senNumber?: string;
  isPartner: boolean;
  isCollapsedAll?: boolean;
  isArchived?: boolean;
  isTrial?: boolean;
  endUserView?: boolean;
};

const MACTableContent = ({
  items,
  tableType,
  senNumber,
  isCollapsedAll,
  isPartner,
  endUserView,
}: MACTableContentProps) => {
  const isDisplayable = useMemo(() => {
    if (tableType !== MACTableType.orders) return true;
    if (senNumber && items && items[0]) return isQuoteDisplayable(items[0]);
    return true;
  }, [tableType, senNumber, items]);

  const RowComponent = useMemo(
    () => (endUserView ? EndUserCollapseRow : CollapseRow),
    [endUserView],
  );

  return (
    <tbody>
      {items.length > 0 && isDisplayable ? (
        <>
          {tableType === MACTableType.orders && senNumber ? <SingleQuoteTableContent /> : null}
          {tableType === MACTableType.invoices && senNumber ? <SingleInvoiceTableContent /> : null}
          {items.map((item) => (
            <RowComponent
              key={item.id || item.accountId || item.licenseId}
              rowItem={item}
              tableType={tableType}
              senNumber={senNumber}
              isCollapsedAll={isCollapsedAll}
              isPartner={isPartner}
            />
          ))}
        </>
      ) : (
        <NoItemsTableContent tableType={tableType} isPartner={isPartner} />
      )}
    </tbody>
  );
};

export default MACTableContent;
